require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-bic-along-with-over-200-civil-society-partners-sent.json") })
        }
      }, "path---en-us-update-bic-along-with-over-200-civil-society-partners-sent");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-bic-along-with-over-200-civil-society-partners-sent!./.cache/json/en-us-update-bic-along-with-over-200-civil-society-partners-sent.json
// module id = 620
// module chunks = 231608221292675